import { gql } from "graphql-tag";

export const replyQa = gql`
  mutation replyQA($input: CreateQuestionPostComment!) {
    commentQuestionPost(input: $input) {
      id
      createdAt
      updatedAt
      postId
      userId
      isAdmin
      detail
    }
  }
`;

export const updateQa = gql`
  mutation updateQA($input: UpdateQuestionPostComment!) {
    updateQuestionPostComment(input: $input) {
      id
      detail
    }
  }
`;
export const deleteQa = gql`
  mutation DeleteQuestionPost($id: ID!) {
    deleteQuestionPost(id: $id) {
      message
    }
  }
`;
